import React from 'react';
import Connect from './Connect'

const path = process.env.PUBLIC_URL

const GuideInterval = ({ choices, handleAnswer, selectedAnswer, answers }) => {
  return (
    <div className="guide intro__container mt-0 md:mt-[2.5vh] rounded-tl-0 rounded-tr-0 md:rounded-tl-[20px] md:rounded-tr-[20px]">
      <h2><span>改错题</span></h2>
      <div className="intro">
        <div className="intro__text">
          我们会提供几个能播的词语。请找出歌词中有可能不能播的敏感词，并拖拽合适的备选词替换。
        </div>
      </div>
      <img src={`${path}/images/start.svg`} className="absolute w-[60px] top-[35px] right-[5px] z-10" />
      <img src={`${path}/images/eye.svg`} className="absolute w-[120px] bottom-[26px] left-[50%] z-10 translate-x-[-50%]" />
      <div className="absolute w-[calc(100%_-_60px)]">
        <div className="intro__subtitle">
          【小练习】<br/>Bye Bye ｜ 旅行团
        </div>
        <div className="intro__demo">
          <Connect
            handleAnswer={handleAnswer}
            scripts={choices}
            word={answers}
          />
        </div>
      </div>
    </div>
  );
};

export default GuideInterval;